import script from "./web.vue?vue&type=script&setup=true&lang=js"
export * from "./web.vue?vue&type=script&setup=true&lang=js"

import "./web.vue?vue&type=style&index=0&id=037b25d3&lang=less"
import "./web.vue?vue&type=style&index=1&id=037b25d3&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037b25d3"]])

export default __exports__